import store from '@/store/index';
import { REFERRAL_REWARD_TYPE_PERCENTAGE } from '@/store/modules/refer-a-friend';
import {
  isZoomOneBusinessPlan,
  isZoomOneProPlan,
  BILLING_CYCLE,
  isZoomOneBusinessPlusPlan,
  isZoomOneProPlusPlan,
} from '@/common/constants';
import { billingCycleToValueMap } from '@/utils';

export const getReferAFriendDiscountAmount = () => {
  const { isEligibleForReferAFriendDiscount, referAFriendRewardType, referAFriendRewardValue, getSelectedPlans } = store.getters;

  const basePlans = getSelectedPlans?.filter((p) => isZoomOneProPlan(p) || isZoomOneProPlusPlan(p) || isZoomOneBusinessPlan(p) || isZoomOneBusinessPlusPlan(p)) || [];

  if(!isEligibleForReferAFriendDiscount || basePlans.length === 0 || referAFriendRewardValue === 0) {
    return 0;
  }

  let totalDiscount = 0;

  if (referAFriendRewardType === REFERRAL_REWARD_TYPE_PERCENTAGE) {
    // Calculate discount for each base plan
    basePlans.forEach((basePlan) => {
      const selectedNumber = basePlan?.cartInfo?.selected_number ?? 1;
      
      // Calculate the amount per billing cycle
      let amountPerCycle = basePlan.amount;

      // For annual_term_monthly, the amount stored is annual but charged monthly
      // So we need to divide by 12 to get the monthly payment amount
      if (basePlan.billing_cycle === BILLING_CYCLE.ANNUAL_TERM_MONTHLY) {
        amountPerCycle = basePlan.amount / billingCycleToValueMap[BILLING_CYCLE.ANNUAL_TERM_MONTHLY];
      }

      // Calculate percentage discount based on the amount charged per cycle
      totalDiscount += (amountPerCycle * selectedNumber * Number(referAFriendRewardValue)) / 100;
    });
  } else {
    // Fixed amount discount - apply once for all base plans
    totalDiscount = Number(referAFriendRewardValue * 100);
  }

  return -Math.abs(totalDiscount);
};
